// components/common/BlurLoadingDots.jsx
import React, { useEffect } from 'react';

let injected = false;
function injectCSS() {
    if (injected) return;
    injected = true;
    const css = `
    @keyframes dotBounce {
      0%,80%,100% { transform: translateY(0) }
      40% { transform: translateY(-8px) }
    }
    .dots { display:inline-flex; gap:8px; align-items:center }
    .dots span {
      width:10px; height:10px; border-radius:50%;
      background: #6366f1; animation: dotBounce 1s infinite ease-in-out;
    }
    .dots span:nth-child(2){ animation-delay:.12s; background:#3b82f6 }
    .dots span:nth-child(3){ animation-delay:.24s; background:#22d3ee }
  `;
    const style = document.createElement('style');
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
}

export default function LoadingOverlay({
    loading,
    children,
    className,
    blurPx = 4,
    dimOpacity = 0.5,
    blockClicks = true,
    centered = true,
    showBackdrop = false,
}) {
    useEffect(injectCSS, []);

    const wrapper = { position: 'relative' };
    const content = {
        filter: loading ? `blur(${blurPx}px)` : 'none',
        opacity: loading ? dimOpacity : 1,
        transition: 'filter 140ms ease, opacity 140ms ease',
        pointerEvents: loading && blockClicks ? 'none' : 'auto',
    };
    const overlay = {
        position: 'absolute', inset: 0, zIndex: 6,
        display: loading ? 'flex' : 'none',
        alignItems: centered ? 'center' : 'flex-start',
        justifyContent: centered ? 'center' : 'flex-start',
        padding: centered ? 0 : 8,
        background: showBackdrop ? 'rgba(255,255,255,.5)' : 'transparent',
        backdropFilter: showBackdrop ? 'blur(1px)' : 'none',
        WebkitBackdropFilter: showBackdrop ? 'blur(1px)' : 'none',
        borderRadius: 8,
    };

    return (
        <div className={className} style={wrapper} aria-busy={!!loading}>
            <div style={content}>{children}</div>
            <div style={overlay}>
                <div className="dots"><span /><span /><span /></div>
            </div>
        </div>
    );
}
